<div class="pt-3 pl-md-4" *ngIf="!accountService.getMyAccount().is_organization_admin">
  <h2>You do not have permission to manage payment processor connections.</h2>
</div>

<div class="pt-3 pl-md-4" *ngIf="serverError !== null">
  <h2>Server Error: {{ serverError }}</h2>
</div>

<div class="alert mt-3 ml-md-4 mb-0" role="alert"
     [class.alert-success]="history.state.feedback.status == 'success'"
     [class.alert-info]="history.state.feedback.status == 'info'"
     *ngIf="history && history.state && history.state.feedback">
  {{ history.state.feedback.text }}
</div>

<div class="pt-3 pl-md-4 mb-6"
     *ngIf="accountService.getMyAccount().is_organization_admin && serverError === null">

  <h2>Payment Processor Connections <span *ngIf="loadingConns" class="text-secondary">- Loading...</span></h2>

  <div class="alert alert-success" *ngIf="successMessage">{{ successMessage }}</div>
  <div class="alert alert-danger" *ngIf="errorMessage">{{ errorMessage }}</div>
  <div class="alert" role="alert"
       [class.alert-success]="modalResult.status === CallbackResultStatus.success"
       *ngIf="modalResult !== null">
    {{ modalResult.text }}
  </div>

  <div class="rounded-table-wrapper table-responsive-lg">
    <table class="table">

      <thead>
      <tr>
        <th scope="col">Type</th>
        <th scope="col">Name</th>
        <th scope="col">Locations</th>
        <th scope="col"></th>
      </tr>
      </thead>

      <tbody *ngIf="resultsPresent()">
      <tr *ngFor="let conn of conns.results">
        <td>{{ getPaymentProcessorTypeDisplay(conn.payment_processor) }}</td>
        <td>{{ conn.name }}</td>
        <td>
          <ng-container *ngIf="conn.location_names.length > 0">
            <span *ngFor="let location_name of conn.location_names" class="d-block">{{ location_name }}</span>
          </ng-container>
          <span class="text-muted" *ngIf="conn.location_names.length === 0">
            None assigned
          </span>
        </td>
        <td class="table-button-cell">
          <div class="float-right">
            <a routerLink="/payment-processor-connections/configure/{{ conn.id }}"
               class="btn btn-outline-success btn-sm mr-2">
              Configure
            </a>
            <button type="button" class="btn btn-outline-success btn-sm mr-2"
                    (click)="handleAssignConn(conn)">
              Assign
            </button>
            <button type="button" class="btn btn-outline-danger btn-sm mr-2"
                    (click)="handleRemoveConn(conn)">
              Remove
            </button>
          </div>
        </td>
      </tr>
      </tbody>

      <tbody *ngIf="!resultsPresent()">
      <tr>
        <td colspan="99">
          {{ loadingConns ? 'Loading...' : 'No connections' }}
        </td>
      </tr>
      </tbody>

    </table>
  </div>

  <p>
    Your organization can have multiple payment processor connections. This allows you to collect payments separately for individual or subsets of locations.
  </p>

  <a [href]="getStripeOAuthInitURL()"
     class="btn btn-primary mb-2">
    Connect with Stripe
  </a>

  <br>

  <button (click)="openAddMxMerchantConnectionModal()"
          class="btn btn-primary mb-2">
    Add Priority / MX Merchant Connection
  </button>

</div>
